import styled from 'styled-components';

export const SettingsLabel = styled.p`
  margin: 12px 0 0 0;
  padding: 0;
  font-size: 12px;
  font-weight: 300;
  text-align: center;
  color: #212121;
`;
